import { defineStore } from 'pinia';
import { useAcvFetch } from '@/composables/useAcvFetch';
import { useNotificationsStore } from '@/stores/useNotifications';
import useDatadogAddError from '@/composables/useDatadogAddError';
import { notificationKeys } from '@/constants/notificationKeys';

export const useCarrierFleetStore = defineStore({
  id: 'carrierFleetStore',
  state: () => {
    return {
      fleet: {},
    };
  },
  actions: {
    async getCarrierFleetInfo() {
      const { data, pending, error } = await useAcvFetch(
        `v1/api/carrier/fleet`
      );
      if (error.value) {
        return {
          status: error.value.statusCode,
        };
      }
      this.fleet = data.value.data;
      return { fleet: data.value.data, pending };
    },
    async updateCarrierFleetInfo(body) {
      const notificationsStore = useNotificationsStore();
      const { data, pending, error } = await useAcvFetch(
        `v1/api/carrier/fleet/create`,
        {
          method: 'POST',
          body: body,
        }
      );
      if (error.value) {
        const customError = new Error('500 update fleet');
        useDatadogAddError(customError, body);

        const notificationParams = {
          notificationMessageTemplate:
            '<span class="tw-font-medium">Unable to update fleet info.</span>  Please check connection and try again.',
          variant: 'error',
          key: notificationKeys.errorEditVehicleInfo,
        };
        notificationsStore.addNotification(notificationParams);
        return error;
      }

      const notificationParams = {
        notificationMessageTemplate: 'Fleet information successfully updated.',
        variant: 'success',
        key: notificationKeys.successEditVehicleInfo,
      };
      notificationsStore.addNotification(notificationParams);
      this.fleet = data.value.data;
      return { fleet: data.value.data, pending };
    },
  },
  getters: {
    totalFleetCapacity: (state) => state.fleet?.totalFleetCapacity,
    oversizedVehiclesAccepted: (state) =>
      state.fleet?.oversizedVehiclesAccepted,
    hasWinch: (state) => state.fleet?.hasWinch,
    hasFlatbed: (state) => state.fleet?.hasFlatbed,
    hasRollback: (state) => state.fleet?.hasRollback,
    hasEnclosedTrailer: (state) => state.fleet?.hasEnclosedTrailer,
  },
});
